export const LANGUAGE_ES = "es"
export const LANGUAGE_EN = "en"

export type allowedLanguages = "es" | "en" | string
export type LanguageDictionary = {
	[key: string]: allowedLanguages
}
export const LANGUAGES: LanguageDictionary = {
	LANGUAGE_ES: "es",
	LANGUAGE_EN: "en",
}
